import React, { useState, useEffect } from 'react';
import { WorkflowList } from './WorkflowList';
import { WorkflowBuilder } from './WorkflowBuilder';
import { WorkflowHistory } from './WorkflowHistory';
import type { ApprovalWorkflow } from '@/types/workflow';
import type { Employee } from '@/types/timesheet';

type View = 'list' | 'create' | 'edit' | 'history';

interface WorkflowManagementProps {
  employees: Employee[];
  isDemo?: boolean;
  isLive?: boolean;
}

export function WorkflowManagement({ employees, isDemo = true, isLive = false }: WorkflowManagementProps) {
  const [view, setView] = useState<View>('list');
  const [selectedWorkflow, setSelectedWorkflow] = useState<ApprovalWorkflow | undefined>();

  const handleCreate = () => {
    setSelectedWorkflow(undefined);
    setView('create');
  };

  const handleEdit = (workflow: ApprovalWorkflow) => {
    setSelectedWorkflow(workflow);
    setView('edit');
  };

  const handleViewHistory = (workflow: ApprovalWorkflow) => {
    setSelectedWorkflow(workflow);
    setView('history');
  };

  const handleSave = () => {
    setView('list');
    setSelectedWorkflow(undefined);
  };

  const handleCancel = () => {
    setView('list');
    setSelectedWorkflow(undefined);
  };

  const handleCloseHistory = () => {
    setView('list');
    setSelectedWorkflow(undefined);
  };

  return (
    <div className="container mx-auto py-6">
            {view === 'list' && (
              <WorkflowList
                onCreate={handleCreate}
                onEdit={handleEdit}
                onViewHistory={handleViewHistory}
                isDemo={isDemo}
                isLive={isLive}
              />
            )}

      {(view === 'create' || view === 'edit') && (
        <WorkflowBuilder
          workflow={selectedWorkflow}
          employees={employees}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}

      {view === 'history' && selectedWorkflow && (
        <WorkflowHistory workflow={selectedWorkflow} onClose={handleCloseHistory} />
      )}
    </div>
  );
}
